import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=828bbaf6&scoped=true&"
import script from "./addPrice.vue?vue&type=script&lang=js&"
export * from "./addPrice.vue?vue&type=script&lang=js&"
import style0 from "./addPrice.vue?vue&type=style&index=0&id=828bbaf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828bbaf6",
  null
  
)

export default component.exports